export * from './auth';
export * from './auth.module';
//# sourceMappingURL=public_api.js.map


//////////////////
// WEBPACK FOOTER
// /Users/azerty/friendlychat-web/cloud-functions-angular-start/~/angularfire2/auth/public_api.js
// module id = ../../../../angularfire2/auth/public_api.js
// module chunks = 3